import React from 'react';
import { Root, createRoot } from 'react-dom/client';

import { Blocks } from './components/SectionBlocks';
import { PDFPreview } from './components/pdf-preview';

export type SectionData = {
  id: string;
  headline?: string | null;
  topline?: string | null;
  blocks: Blocks;
};

export type SectionFooterData = {
  headline: string;
  contacts: {
    firstName: string;
    lastName: string;
    phone: string;
    email: string;
    jobTitle: string;
    image?: string | null;
  }[];
  image?: string | null;
  companyName: string;
  address: string;
  website: string;
};

export type PdfGeneratorData = {
  title: string;
  topline?: string | null;
  subline?: string | null;
  image?: string | null;
  showTableOfContents: boolean;
  sections: SectionData[];
  footer: SectionFooterData;
};

let root: Root | undefined;

const PdfGenerator = (element: HTMLElement | Element) => ({
  init() {
    const configDiv = element.querySelector('.pdf-generator__config');
    const configRaw = configDiv?.getAttribute('data-config');
    const container = element.querySelector('.pdf-generator__container');

    if (!root) {
      root = createRoot(container);
    }

    const data: PdfGeneratorData = JSON.parse(configRaw ?? '');
    root.render(<PDFPreview {...data} />);
  }
});

export default PdfGenerator;
